// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"MR-z","categoryName":"NR-z","categoryNameSearchHeader":"OR-z","categoryContent":"PR-z","bottomAligned":"QR-z","image":"RR-z","imageNoBackground":"SR-z"};